// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseProdConfig = {
  apiKey: "AIzaSyD-We8ZLAbLTwIXSNsFZhQ1yV38lN5fvEU",
  authDomain: "fep-quidio.firebaseapp.com",
  projectId: "fep-quidio",
  storageBucket: "fep-quidio.appspot.com",
  messagingSenderId: "102804652198",
  appId: "1:102804652198:web:7ee1ec6058fd9723db3467",
  measurementId: "G-YZCBQ80ZRX"
};